import {
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptor
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { ErrorDialogService } from "../../shared/services/error-dialog.service";
import { LoadingDialogService } from "../../shared/services/loading-dialog.service";
import { Injectable } from "@angular/core";
import {NGXLogger} from "ngx-logger";
import {environment} from "../../../environments/environment";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private errorDialogService: ErrorDialogService,
    private loadingDialogService: LoadingDialogService,
    private logger: NGXLogger,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (environment.show_error_dialogs) {
      this.loadingDialogService.openDialog();
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.logger.error("Error from error interceptor", error);
        if (environment.show_error_dialogs) {
          this.errorDialogService.openDialog(error.message ?? JSON.stringify(error), error.status);
        }
        return throwError(error);
      }),
      finalize(() => {
        if (environment.show_error_dialogs) {
          this.loadingDialogService.hideDialog();
        }
      })
    ) as Observable<HttpEvent<any>>;
  }
}
